<template>
    <div class="alert alert-danger">
        <b>Ticket Closed</b>
        <p class="mb-0">
            {{ ticket.closing_note }}
        </p>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: "TicketClosingNote",
        computed: {
            ...mapGetters('ticketViewer', {
                ticket: 'ticket'
            })
        }
    }
</script>

<style scoped>

</style>
